"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("./ClearFilter.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClearFilter = function ClearFilter(props, context) {
  var _context$location = context.location,
      pathname = _context$location.pathname,
      query = _context$location.query;
  var activeFilters = props.activeFilters,
      className = props.className,
      defaultFilters = props.defaultFilters,
      onClear = props.onClear,
      to = props.to;

  var hasChangedFilters = Object.keys(activeFilters).length && Object.keys(activeFilters).some(function (key) {
    var actFilter = activeFilters[key];
    var defFilter = defaultFilters[key];

    if (Array.isArray(actFilter) && Array.isArray(defFilter)) {
      return actFilter.length !== defFilter.length || actFilter.some(function (el) {
        return defFilter.indexOf(el) < 0;
      });
    }

    return actFilter != defFilter;
  });

  if (!hasChangedFilters) {
    return null;
  }
  return _react2.default.createElement(
    "a",
    {
      className: (0, _classnames2.default)("erg-components-ClearFilter", "erg-font-sm", "erg-margin-left-10", className),
      onClick: function onClick() {
        return onClear({
          pathname: to || pathname,
          query: _extends({}, query, defaultFilters)
        });
      } },
    _react2.default.createElement(
      "span",
      { className: "text-danger" },
      "\xD7"
    ),
    " Reset Filters"
  );
};

ClearFilter.contextTypes = {
  location: _propTypes2.default.object.isRequired
};

ClearFilter.defaultProps = {
  defaultFilters: {}
};

ClearFilter.displayName = "ClearFilter";

ClearFilter.propTypes = {
  activeFilters: _propTypes2.default.any,
  className: _propTypes2.default.string,
  defaultFilters: _propTypes2.default.any,
  onClear: _propTypes2.default.func.isRequired,
  to: _propTypes2.default.string
};

exports.default = ClearFilter;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/filters/ClearFilter.js
 ** module id = 393
 ** module chunks = 0
 **/